
import { meses } from "../data/datos"

export function formatearFecha( fecha ) {

    var arr_f = fecha.split('-')
    return meses[ arr_f[ 1 ] - 1 ] + " de " + arr_f[0]

}

export function formatearFechaSpanish( fecha, conHora = true ) {

    fecha = conHora ? fecha : fecha+'T00:00:00'
    fecha = new Date(fecha)
    const opciones = { year: 'numeric', month: 'long', day: 'numeric' }
    return fecha.toLocaleDateString('es-MX', opciones)

}

export function diferenciaEnDias(f1, f2) {
    const fecha1 = new Date(f1)
    const fecha2 = new Date(f2)
    return Math.floor((fecha2 - fecha1) / (1000 * 60 * 60 * 24)) + 1
}

export function sumarUnDia(fecha) {
    fecha = new Date(fecha);
    fecha.setDate(fecha.getDate() + 1);
    return fecha.toISOString().split("T")[0]
}
